import RowCountSelector from '../RowCountSelector';
import Paginator from '../Paginator';

import styles from './VisitsFooter.module.scss';

const VisitsFooter = () => (
  <footer className={styles.visitsFooter}>
    <div className={styles.content}>
      <RowCountSelector />
      <Paginator />
    </div>
  </footer>
);

export default VisitsFooter;
